<div class="layout-actionbar p-grid">

    <div class="layout-breadcrumb"
        style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center;">
        <div class="" *ngFor="let item of items; let i = index">
            <i class="pi pi-chevron-right" style="font-size: 24px; margin-right: 20px;" *ngIf="i !== 0"></i>
            <span style="font-size: 24px; font-weight: 600; margin-right: 20px; cursor: pointer;"
                [routerLink]="item.routerLink[0]">{{ item.label }}</span>
        </div>
        <!-- <p-breadcrumb [model]="items"></p-breadcrumb> -->
        <!-- <div class="route-bar-breadcrumb">
            <ng-template ngFor let-item let-last="last" [ngForOf]="items">
                <li>
                    <a [routerLink]="item.routerLink" class="ui-link ui-widget" *ngIf="item.routerLink">{{item.label}}</a>
                    <ng-container *ngIf="!item.routerLink">{{item.label}}</ng-container>
                </li>
            </ng-template>
        </div> -->
    </div>


    <div class="layout-actions p-col-12 p-md-6 p-lg-6" style="margin-right: 18px;">

        <p-dropdown *ngFor="let dropdown of dropdowns" [autoDisplayFirst]="false" [options]="dropdown.options"
            [style]="{width: '200px', 'float': 'right'}" [ngModel]="dropdown.initvalue"
            (onChange)="onChangeDropdown($event, dropdown.name)"></p-dropdown>
        <button *ngFor="let label of newButtons" pButton icon="pi pi-plus" type="button"
            class="p-button-raised p-button-success" style="float:right" (click)="onNew(label)"
            [label]="label"></button>
        <button *ngIf="showCardsButton" pButton type="button"
            class="p-button-raised p-button-success" style="float:right" (click)="onShowAllCards()"
            label="Show Cards"></button>
        <!-- <p-button *ngFor="let label of newButtons" pButton icon="pi pi-plus" type="button" [outlined]="true" severity="secondary" style="float:right" (click)="onNew(label)" [label]="label"></p-button> -->
        <p-button *ngIf="showExportButton" icon="pi pi-download" type="button" iconPos="right" [outlined]="true"
            severity="secondary" (click)="onDownload()" label="Export to CSV"></p-button>
    </div>
</div>